import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

/** User module. */
export const userModule = {
    state,
    getters,
    mutations,
    actions,
};

/**
 * Reset password action payload.
 *
 * @export
 * @interface ResetPasswordPayload
 */
export interface ResetPasswordPayload {
    /**
     * Reset password token.
     *
     * @type {string}
     * @memberof ResetPasswordPayload
     */
    token: string;

    /**
     * Password to reset to.
     *
     * @type {string}
     * @memberof ResetPasswordPayload
     */
    password: string;
}
